const cloneArray = (array) => {
    return JSON.parse(JSON.stringify(array));
}

export default cloneArray;